<template>
  <nav class="navbar navbar-expand-lg navbar-dark">
      <div class="container-fluid">
        <a class="navbar-brand align-items-center" href="/">
          <img src="../assets/logo_celeste.svg" alt="logo mercatur celeste" class="nav-logo">
        </a>
        <button 
          class="navbar-toggler" 
          type="button" 
          data-bs-toggle="offcanvas" 
          data-bs-target="#navbarNav" 
          aria-controls="navbarNav" 
          aria-expanded="false" 
          aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="offcanvas offcanvas-end" id="navbarNav">
          <div class="offcanvas-header">
            <img src="../assets/isotipo_blanco.png" alt="logo mercatur celeste" class="nav-logo-mobile">
            <button type="button" class="btn-close btn-close-white p-4" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <ul class="navbar-nav text-lg-center text-start text-4">
            <li class="nav-item">
              <router-link class="nav-link ws-14" exact-active-class="active-link" aria-current="page" :to="{name: 'home', hash: '#'+'services'}" @click="closeMenu">Nuestros Servicios</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link ws-14" exact-active-class="active-link" aria-current="page" :to="{name: 'home', hash: '#'+'somos'}" @click="closeMenu">Sobre Nosotros</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link ws-14" exact-active-class="active-link" aria-current="page" :to="{name: 'home', hash: '#'+'testimonios'}" @click="closeMenu">Nuestros Clientes</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link ws-14" exact-active-class="active-link" aria-current="page" :to="{name: 'home', hash: '#'+'faqs'}" @click="closeMenu">Preguntas Frecuentes</router-link>
            </li>
            <ButtonComp 
              :btnColor="'btn-primary'" 
              :buttonText="'Contacto'"
              data-tally-open="w26W7g"
              data-tally-layout="modal"
              data-tally-width="700"
              class="btn-mobile"
              />
          </ul>
        </div>
      </div>
    </nav>
</template>

<script>
import ButtonComp from '@/components/ButtonComp.vue';

export default {
  name: 'HeaderComp',
  components: {
    ButtonComp
  },
  mounted() {
    const navbarNav = document.getElementById('navbarNav');
    const navbar = this.$refs.navbar;

    // Escucha cuando el menú se abre
    navbarNav.addEventListener('show.bs.collapse', () => {
      navbar.classList.add('navbar-open');
    });

    // Escucha cuando el menú se cierra
    navbarNav.addEventListener('hide.bs.collapse', () => {
      navbar.classList.remove('navbar-open');
    });
  },
  methods: {
  closeMenu() {
    const navbarNav = document.getElementById('navbarNav');
    if (navbarNav) {
      // Cierra el menú quitando la clase 'show'
      navbarNav.classList.remove('show');
    }

    // Elimina cualquier capa de fondo existente
    const backdrops = document.querySelectorAll('.offcanvas-backdrop');
    backdrops.forEach((backdrop) => backdrop.remove());

    // Restaura el scroll del body
    document.body.classList.remove('offcanvas-backdrop');
    document.body.style.overflow = '';
  }
}
}

</script>